
@let isReverse = officialViewService.areSidesReversed;

<div #fixedContent>
    <div class="sb-body-wrapper" #scoreboard>
        <div class="wrap-body">
            <app-sb-body [match]="match" [tie]="tie"></app-sb-body>
        </div>
    </div>

     @if (match?.matchStatus !== 'TBP') {
        <ion-card style="margin: 0" class="score-read-wrap">
            <ion-card-content class="score-read">
                <ion-icon name="volume-high"></ion-icon>
                @if (match.score?.server?.sideNumber === 1) {
                    {{ match.score?.side1PointScore }}-{{ match.score?.side2PointScore }}@if(match.score?.server?.serverNumber) {-{{ match.score?.server?.serverNumber }} }
                } @else {
                    {{ match.score?.side2PointScore }}-{{ match.score?.side1PointScore }}@if(match.score?.server?.serverNumber) {-{{ match.score?.server?.serverNumber }} }
                }
            </ion-card-content>
            <div class="top-row-stopwatch">
                Match<app-match-duration [match]="match"></app-match-duration>
            </div>
        </ion-card>
    }

    <!-- TODO selectedSet is not needed for Pickleball. It is used to show violations for tennis -->
    <div class="point-row-score" [ngClass]="{'squash': match.discipline === 'SQUASH'}">
        <app-point-row #pointRow
            [point]="lastPoint"
            [game]="lastGame"
            [sets]="match.sets"
            [sides]="match.sides"
            [timeItems]="match.timeItems"
            [discipline]="match.discipline"
            [scoreFormat]="scoreFormat"
            [selectedSet]="1"
            [showScore]="false"
            [playerCellType]="'official-view'"
            [areSidesReveresed]="isReverse"
            [matchType]="match.matchType"
            [matchStatus]="match?.matchStatus !== 'TBP'">
        </app-point-row>
        @if(match?.matchStatus !== 'TBP'){
            <div class="swap-side">
                <app-swap-side [match]="match"></app-swap-side>
            </div>
        }
    </div>    
</div>

<div class="bottom-container {{match?.matchStatus != 'TBP' ? 'add-color' : '' }}" [ngClass]="{'squash': match.discipline === 'SQUASH'}">
@if (match?.matchStatus === 'TBP') {
    <ion-row>
        <ion-col style="margin: 30px" class="ion-text-center">
            <app-start-match [match]="match" itemStyle="official"></app-start-match>
        </ion-col>
    </ion-row>
} @else if (match.matchStatus === 'SUSPENDED') {
    <ion-row [style.height.px]="rowHeight / 3">
        <ion-col size="12">
            <ion-button style="height: 100%;" (click)="resumeSuspendedMatch.emit(true)" expand="block" color="tertiary">
                Resume suspended match
            </ion-button>
        </ion-col>
    </ion-row>
} @else {
    @if(match.discipline !== 'BADMINTON' && match.discipline !== 'TABLE_TENNIS' && match.discipline !== 'SQUASH') {
    <ion-row class="timeout-wrapper 1" #timeoutWrapper>
        <ion-col class="app-timeout">
            <app-timeout 
                [match]="match" 
                [tie]="tie" 
                [sideColors]="sideColors"
                [isTimeoutClock]="isTimeoutClock"
                [matchTimeout]="matchTimeout"
                [sideName]="isReverse ? 'side2' : 'side1'"
                [rowHeight]="rowHeight / 5.15"
                (timeoutEndEvent)="onTimeoutEnd()"
                (timeoutStarted)="onTimeoutStarted($event)"
                (timeoutUndo)="onTimeoutUndo($event)">
            </app-timeout>
        </ion-col>
        <ion-col class="serve-clock" [style.height.px]="rowHeight / 5.15" [style.gap.px]="rowHeight / 40">
            @if(match.matchStatus === 'TBP') {
                <div class="top-row-label" [style.font-size.px]="(rowHeight / 5.15) / 6">Warm up</div>   
                <div [style.font-size.px]="(rowHeight / 5.15) / 3.2">          
                    <app-stopwatch [showButtons]="false" #warmUpClock [match]="match" [clockInputValue]="getClock(clockName.WARM_UP)" [displayType]="'PLAIN'"></app-stopwatch>
                </div>
            } @else {
                <div class="top-row-label" [style.font-size.px]="(rowHeight / 5.15) / 5.5">SERVE CLOCK</div> 
                <div class="show-colan" [style.font-size.px]="(rowHeight / 5.15) / 3.2"> 
                @if(getClock(clockName.POINT_BREAK) && getClock(clockName.POINT_BREAK)?.timePipe === 'ss'){
                    <span [style.font-size.px]="(rowHeight / 5.15) / 3.2">:</span> 
                }          
                <app-stopwatch [showButtons]="false" #pointBreakClock [match]="match" [clockInputValue]="getClock(clockName.POINT_BREAK)" [displayType]="'PLAIN'"></app-stopwatch>
                </div>
            }

            @if(scoreFormat?.timedSetDuration > 0) {
                <div class="top-row-label" [style.font-size.px]="(rowHeight / 5.15) / 6">Time</div>    
                <div [style.font-size.px]="(rowHeight / 5.15) / 3.2">         
                    <app-stopwatch [showButtons]="false" #setTimeClock [match]="match" [clockInputValue]="getClock(clockName.SET_TIME)" [displayType]="'PLAIN'"></app-stopwatch>
                </div>
            }
        </ion-col>
        <ion-col  class="app-timeout">
            <app-timeout 
                [match]="match" 
                [tie]="tie" 
                [sideColors]="sideColors"
                [isTimeoutClock]="isTimeoutClock"
                [matchTimeout]="matchTimeout"
                [sideName]="isReverse ? 'side1' : 'side2'"
                [rowHeight]="rowHeight / 5.15"
                (timeoutEndEvent)="onTimeoutEnd()"
                (timeoutStarted)="onTimeoutStarted($event)"
                (timeoutUndo)="onTimeoutUndo($event)">
            </app-timeout>
        </ion-col>
    </ion-row>
    }
        
    @if(isGameTypeRallyOrMLP){
        <ion-row class="point-container"  [style.height.px]="!timeoutWrapper ? rowHeight : rowHeight / 1.25">
            <ion-col>
                <app-int-point-container
                    [sideColors]="sideColors"
                    [sideName]="isReverse ? 'side2' : 'side1'"
                    [rowHeight]="rowHeight / 5"
                    [isReverse]="isReverse"
                    [match]="match"
                    (pointScored)="addPointScore($event.sideNumber, $event.points)"
                    [sideNumber]="isReverse ? 2 : 1"
                    [colHeight]="!timeoutWrapper ? rowHeight : rowHeight / 1.25">
                </app-int-point-container>
            </ion-col>

            <ion-col>
                <app-int-point-container
                    [sideColors]="sideColors"
                    [sideName]="isReverse ? 'side1' : 'side2'"
                    [rowHeight]="rowHeight / 5"
                    [isReverse]="isReverse"
                    [match]="match"
                    (pointScored)="addPointScore($event.sideNumber, $event.points)"
                    [sideNumber]="isReverse ? 1 : 2"
                    [colHeight]="!timeoutWrapper ? rowHeight : rowHeight / 1.25">
                </app-int-point-container>
            </ion-col>
        </ion-row>
        } @else {
            <ion-row class="add-point-side" [style.height.px]="!timeoutWrapper ? rowHeight : rowHeight / 1.25">
                <ion-col>
                    <app-add-point-side
                        [sideNumber]="isReverse ? 2 : 1"
                        (addPoint)="addPoint($event)"
                        [serverNumber]="match.score.server.serverNumber"
                        [serverSide]="match.score.server.sideNumber" 
                        [rowHeight]="!timeoutWrapper ? rowHeight : rowHeight / 1.25"
                        >
                    </app-add-point-side>
                </ion-col>
                <ion-col>
                    <app-add-point-side
                        [sideNumber]="isReverse ? 1 : 2"
                        (addPoint)="addPoint($event)"
                        [serverNumber]="match.score.server.serverNumber"
                        [serverSide]="match.score.server.sideNumber"
                        [rowHeight]="!timeoutWrapper ? rowHeight : rowHeight / 1.25" >
                    </app-add-point-side>
                </ion-col>
            </ion-row>
        }
}
</div>